import { useState, useEffect } from 'react'

type PersistedCollapse = {
  expanded: boolean
  toggle: () => void
}

export const usePersistedCollapse = (
  key: string | null,
  defaultExpanded: boolean = true
): PersistedCollapse => {
  const [expanded, setExpanded] = useState<boolean>(() => {
    if (!key) return defaultExpanded
    try {
      const saved = localStorage.getItem(key)
      return saved !== null ? saved === 'true' : defaultExpanded
    } catch {
      return defaultExpanded
    }
  })

  useEffect(() => {
    if (!key) return
    try {
      localStorage.setItem(key, String(expanded))
    } catch {
      //
    }
  }, [expanded, key])

  const toggle = () => setExpanded((prev) => !prev)

  return { expanded, toggle }
}
